<ng-container #containerCharts></ng-container>
